"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchSelectFieldAsync = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var Validators_1 = require("../../../Validators");
var useSearchSelectFieldAsync = function (_a) {
    var multi = _a.multi, disabled = _a.disabled, required = _a.required, validators = _a.validators, fieldState = _a.fieldState, isLoading = _a.isLoading, value = _a.value, onChange = _a.onChange, onLoadData = _a.onLoadData, allowFirstLoad = _a.allowFirstLoad, sort = _a.sort;
    var refInputSearch = (0, react_1.useRef)();
    var firstLoadChange = (0, react_1.useRef)(false);
    var selectionValue = (0, react_1.useRef)(multi ? [] : '');
    var _b = (0, react_1.useState)([]), options = _b[0], setOptions = _b[1];
    var _c = (0, react_1.useState)(false), isOpen = _c[0], changePopoverView = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], changeLoading = _d[1];
    var _e = (0, react_1.useState)(multi ? [] : ''), selection = _e[0], setSelection = _e[1];
    var controller = new AbortController();
    var signal = controller.signal;
    var isDisabledPopover = !!(disabled || isLoading);
    (0, react_1.useEffect)(function () { return onClearComponent; }, []);
    (0, react_1.useEffect)(function () {
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
    }, [validators]);
    (0, react_1.useEffect)(function () {
        (!firstLoadChange.current || allowFirstLoad) && onFirstLoad();
    }, [fieldState === null || fieldState === void 0 ? void 0 : fieldState.value, value]);
    var count = (0, react_1.useMemo)(function () {
        if (multi && (0, lodash_1.isArray)(selection))
            return selection.length;
        return 0;
    }, [selection, multi]);
    var text = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        if (count > 1)
            return '';
        if (!multi) {
            return ((_b = (_a = options.find(function (_a) {
                var valueItem = _a.value;
                if (fieldState)
                    return valueItem === fieldState.value;
                return valueItem === value;
            })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '');
        }
        return ((_d = (_c = options.find(function (_a) {
            var valueItem = _a.value;
            if (fieldState) {
                return ((0, lodash_1.isArray)(fieldState.value) && fieldState.value.includes(valueItem));
            }
            return (0, lodash_1.isArray)(value) && value.includes(valueItem);
        })) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : '');
    }, [fieldState === null || fieldState === void 0 ? void 0 : fieldState.value, value, options]);
    var onFirstLoad = function (load) { return __awaiter(void 0, void 0, void 0, function () {
        var search;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    search = load !== null && load !== void 0 ? load : getValueFirstLoad();
                    if (!!!search) return [3, 2];
                    return [4, onSearchData({ search: search, firstLoad: true })];
                case 1:
                    _a.sent();
                    if (!signal.aborted) {
                        firstLoadChange.current = true;
                        setSelection(search);
                        selectionValue.current = search;
                    }
                    return [2];
                case 2:
                    onClearComponent();
                    return [2];
            }
        });
    }); };
    var getValueFirstLoad = function () {
        if (multi) {
            if ((fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) &&
                (0, lodash_1.isArray)(fieldState.value) &&
                fieldState.value.length) {
                return fieldState.value;
            }
            if (value && (0, lodash_1.isArray)(value) && value.length) {
                return value;
            }
            return null;
        }
        if (!!(fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) && !(0, lodash_1.isArray)(fieldState.value)) {
            return fieldState.value;
        }
        if (!!value && !(0, lodash_1.isArray)(value))
            return value;
        return null;
    };
    var isValue = (0, react_1.useMemo)(function () { return !!getValueFirstLoad(); }, [
        fieldState === null || fieldState === void 0 ? void 0 : fieldState.value,
        value,
        options
    ]);
    var onOpeningPopover = function () {
        var _a, _b;
        (_b = (_a = refInputSearch.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    var onTogglePopover = function () {
        if (!disabled && !(loading || isLoading)) {
            changePopoverView(!isOpen);
        }
    };
    var selectDeselectItem = function (item) {
        if (multi && (0, lodash_1.isArray)(selectionValue.current)) {
            if (selectionValue.current.includes(item.value)) {
                var updateSelection = selectionValue.current.filter(function (value) { return value !== item.value; });
                setSelection(updateSelection);
                selectionValue.current = updateSelection;
            }
            else {
                setSelection(function (current) { return __spreadArray(__spreadArray([], current, true), [item.value], false); });
                selectionValue.current = __spreadArray(__spreadArray([], selectionValue.current, true), [item.value], false);
            }
            return;
        }
        setSelection(item.value);
        selectionValue.current = item.value;
    };
    var handleInteraction = function (nextOpenState, e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    if (!!e && !disabled && !signal.aborted) {
                        if (((_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.className) === null || _c === void 0 ? void 0 : _c.indexOf('gsi-input-select')) !== -1 ||
                            ((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.parentNode) === null || _e === void 0 ? void 0 : _e.className) === null || _f === void 0 ? void 0 : _f.indexOf('gsi-selection-caret')) !== -1) {
                            changePopoverView(nextOpenState);
                        }
                        if (((_j = (_h = (_g = e.target) === null || _g === void 0 ? void 0 : _g.className) === null || _h === void 0 ? void 0 : _h.indexOf) === null || _j === void 0 ? void 0 : _j.call(_h, 'gsi-selection-info-deselect')) !== -1) {
                            changePopoverView(false);
                            return [2];
                        }
                        if (((_k = e.currentTarget) === null || _k === void 0 ? void 0 : _k.className) &&
                            ((_m = (_l = e.currentTarget) === null || _l === void 0 ? void 0 : _l.className) === null || _m === void 0 ? void 0 : _m.indexOf('gsi-select-popover')) !== -1 &&
                            multi) {
                            changePopoverView(true);
                            return [2];
                        }
                    }
                    !disabled && changePopoverView(nextOpenState);
                    if (!!nextOpenState) return [3, 2];
                    changeValueOrField(selectionValue.current);
                    return [4, ((_o = fieldState === null || fieldState === void 0 ? void 0 : fieldState.validate) === null || _o === void 0 ? void 0 : _o.call(fieldState))];
                case 1:
                    _p.sent();
                    return [3, 3];
                case 2:
                    fieldState === null || fieldState === void 0 ? void 0 : fieldState.setError('');
                    _p.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var changeValueOrField = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (fieldState) {
                fieldState.onChange(value);
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
            return [2];
        });
    }); };
    var onSearchData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    changeLoading(true);
                    return [4, (onLoadData === null || onLoadData === void 0 ? void 0 : onLoadData(params))];
                case 1:
                    data = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : [];
                    if (sort) {
                        data = (0, lodash_1.orderBy)(data, ['label'], [sort]);
                    }
                    setOptions(data);
                    changeLoading(false);
                    return [2];
            }
        });
    }); };
    var onClearSearchData = function () { return setOptions([]); };
    var deselectAllItems = function () {
        setSelection([]);
        changeValueOrField([]);
        selectionValue.current = [];
    };
    var onClearComponent = function () {
        firstLoadChange.current = false;
        setOptions([]);
        setSelection(multi ? [] : '');
        selectionValue.current = multi ? [] : '';
        changeLoading(false);
        changePopoverView(false);
        controller.abort();
    };
    var onChangeFirstLoad = function () {
        firstLoadChange.current = true;
    };
    return {
        text: text,
        count: count,
        isOpen: isOpen,
        isValue: isValue,
        loading: loading,
        options: options,
        selection: selection,
        refInputSearch: refInputSearch,
        isDisabledPopover: isDisabledPopover,
        onSearchData: onSearchData,
        onTogglePopover: onTogglePopover,
        deselectAllItems: deselectAllItems,
        onOpeningPopover: onOpeningPopover,
        onClearSearchData: onClearSearchData,
        onChangeFirstLoad: onChangeFirstLoad,
        changePopoverView: changePopoverView,
        handleInteraction: handleInteraction,
        selectDeselectItem: selectDeselectItem
    };
};
exports.useSearchSelectFieldAsync = useSearchSelectFieldAsync;
